function SvgComponent(props: any) {

    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <path
            d="M10.5 3C7.61 3 5.25 5.36 5.25 8.25c0 1.807.923 3.414 2.32 4.36C4.896 13.757 3 16.41 3 19.5h1.5c0-3.323 2.678-6 6-6 1.032 0 1.99.268 2.835.727A5.995 5.995 0 0012 18c0 3.305 2.695 6 6 6s6-2.695 6-6-2.695-6-6-6a5.985 5.985 0 00-3.516 1.148 7.666 7.666 0 00-1.054-.539 5.264 5.264 0 002.32-4.359C15.75 5.36 13.39 3 10.5 3zm0 1.5c2.08 0 3.75 1.67 3.75 3.75S12.58 12 10.5 12s-3.75-1.67-3.75-3.75S8.42 4.5 10.5 4.5zm7.5 9c2.494 0 4.5 2.005 4.5 4.5 0 2.494-2.006 4.5-4.5 4.5a4.488 4.488 0 01-4.5-4.5c0-2.495 2.005-4.5 4.5-4.5zm-.75 1.5v2.25H15v1.5h2.25V21h1.5v-2.25H21v-1.5h-2.25V15h-1.5z"
            fill={props.isHover ? '#F2C94C' : '#ffffff'}
        />
        </svg>
    )
}
  
  export default SvgComponent